export const generateCharacterSVG = (characterId, color, accessory = 'none') => {
  let svg = generateBaseSVG(characterId, color);
  if (accessory && accessory !== 'none') {
    svg = svg.replace('</svg>', renderAccessory(characterId, accessory) + '</svg>');
  }
  return svg;
};

const generateBaseSVG = (characterId, color) => {
  switch(characterId) {
    case 'unicorn':
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <!-- Body -->
          <ellipse cx="100" cy="120" rx="45" ry="40" fill="${color}" />
          
          <!-- Head -->
          <circle cx="100" cy="70" r="40" fill="${color}" />
          
          <!-- Eyes -->
          <ellipse cx="85" cy="65" rx="10" ry="12" fill="white" />
          <ellipse cx="115" cy="65" rx="10" ry="12" fill="white" />
          <ellipse cx="85" cy="65" rx="5" ry="6" fill="black" />
          <ellipse cx="115" cy="65" rx="5" ry="6" fill="black" />
          <ellipse cx="82" cy="62" rx="3" ry="3" fill="white" />
          <ellipse cx="112" cy="62" rx="3" ry="3" fill="white" />
          
          <!-- Blush -->
          <ellipse cx="75" cy="75" rx="10" ry="6" fill="#FF8E8E" opacity="0.6" />
          <ellipse cx="125" cy="75" rx="10" ry="6" fill="#FF8E8E" opacity="0.6" />
          
          <!-- Smile -->
          <path d="M 85 85 Q 100 95 115 85" stroke="black" stroke-width="3" fill="transparent" stroke-linecap="round" />
          
          <!-- Horn -->
          <path d="M 100 40 L 95 15 L 105 15 Z" fill="#FFDE59" />
          <ellipse cx="100" cy="15" rx="5" ry="3" fill="#FFDE59" />
          
          <!-- Ears -->
          <ellipse cx="70" cy="50" rx="15" ry="20" fill="${color}" transform="rotate(-20 70 50)" />
          <ellipse cx="130" cy="50" rx="15" ry="20" fill="${color}" transform="rotate(20 130 50)" />
          <ellipse cx="70" cy="50" rx="8" ry="12" fill="#FFAAD4" transform="rotate(-20 70 50)" />
          <ellipse cx="130" cy="50" rx="8" ry="12" fill="#FFAAD4" transform="rotate(20 130 50)" />
          
          <!-- Legs -->
          <ellipse cx="80" cy="150" rx="8" ry="15" fill="${color}" />
          <ellipse cx="120" cy="150" rx="8" ry="15" fill="${color}" />
          
          <!-- Mane -->
          <path d="M 80 45 Q 90 20 100 45 Q 110 20 120 45" stroke="#FFAAD4" stroke-width="10" fill="transparent" stroke-linecap="round" />
          
          <!-- Tail -->
          <path d="M 55 115 Q 25 100 35 80" stroke="#FFAAD4" stroke-width="10" fill="transparent" stroke-linecap="round" />
        </svg>
      `;

    case 'robot':
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <!-- Head -->
          <rect x="65" y="45" width="70" height="60" rx="15" fill="${color}" />
          
          <!-- Eyes -->
          <circle cx="85" cy="70" r="12" fill="#61DAFB" />
          <circle cx="115" cy="70" r="12" fill="#61DAFB" />
          <circle cx="85" cy="70" r="6" fill="white" />
          <circle cx="115" cy="70" r="6" fill="white" />
          <circle cx="83" cy="68" r="2.5" fill="#61DAFB" />
          <circle cx="113" cy="68" r="2.5" fill="#61DAFB" />
          
          <!-- Mouth -->
          <rect x="80" y="95" width="40" height="5" rx="2.5" fill="#61DAFB" />
          
          <!-- Antenna -->
          <rect x="95" y="35" width="10" height="10" fill="#888" />
          <circle cx="100" cy="30" r="5" fill="#61DAFB" />
          
          <!-- Body -->
          <rect x="70" y="115" width="60" height="45" rx="8" fill="${color}" />
          
          <!-- Neck -->
          <rect x="85" y="105" width="30" height="10" fill="#888" />
          
          <!-- Arms -->
          <rect x="50" y="120" width="20" height="10" rx="5" fill="#888" />
          <rect x="130" y="120" width="20" height="10" rx="5" fill="#888" />
          <rect x="40" y="120" width="10" height="35" rx="5" fill="${color}" />
          <rect x="150" y="120" width="10" height="35" rx="5" fill="${color}" />
          <circle cx="45" cy="155" r="10" fill="${color}" />
          <circle cx="155" cy="155" r="10" fill="${color}" />
          
          <!-- Legs -->
          <rect x="80" y="160" width="15" height="20" rx="5" fill="#888" />
          <rect x="105" y="160" width="15" height="20" rx="5" fill="#888" />
          <rect x="75" y="180" width="25" height="5" rx="2.5" fill="${color}" />
          <rect x="100" y="180" width="25" height="5" rx="2.5" fill="${color}" />
          
          <!-- Buttons -->
          <circle cx="85" cy="128" r="5" fill="#FFDE59" />
          <circle cx="100" cy="128" r="5" fill="#FF8E8E" />
          <circle cx="115" cy="128" r="5" fill="#88EFDD" />
          <rect x="85" y="140" width="30" height="8" rx="4" fill="#61DAFB" />
        </svg>
      `;

    case 'fox':
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <!-- Body -->
          <ellipse cx="100" cy="130" rx="40" ry="35" fill="${color}" />
          
          <!-- Head -->
          <circle cx="100" cy="75" r="40" fill="${color}" />
          
          <!-- Ears -->
          <polygon points="65,45 55,15 80,30" fill="${color}" />
          <polygon points="135,45 145,15 120,30" fill="${color}" />
          <polygon points="65,45 60,25 75,35" fill="white" />
          <polygon points="135,45 140,25 125,35" fill="white" />
          
          <!-- White face -->
          <path d="M 70 55 Q 100 105 130 55" fill="white" />
          
          <!-- Eyes -->
          <ellipse cx="85" cy="65" rx="7" ry="9" fill="black" />
          <ellipse cx="115" cy="65" rx="7" ry="9" fill="black" />
          <ellipse cx="83" cy="63" rx="2" ry="2" fill="white" />
          <ellipse cx="113" cy="63" rx="2" ry="2" fill="white" />
          
          <!-- Nose -->
          <ellipse cx="100" cy="80" rx="7" ry="5" fill="black" />
          
          <!-- Whiskers -->
          <line x1="93" y1="80" x2="75" y2="80" stroke="black" stroke-width="1.5" />
          <line x1="93" y1="83" x2="75" y2="85" stroke="black" stroke-width="1.5" />
          <line x1="107" y1="80" x2="125" y2="80" stroke="black" stroke-width="1.5" />
          <line x1="107" y1="83" x2="125" y2="85" stroke="black" stroke-width="1.5" />
          
          <!-- Smile -->
          <path d="M 90 90 Q 100 100 110 90" stroke="black" stroke-width="1.5" fill="transparent" stroke-linecap="round" />
          
          <!-- Legs -->
          <ellipse cx="80" cy="155" rx="10" ry="15" fill="${color}" />
          <ellipse cx="120" cy="155" rx="10" ry="15" fill="${color}" />
          
          <!-- Tail -->
          <path d="M 145 120 Q 170 100 180 70" stroke="${color}" stroke-width="20" fill="transparent" />
          <path d="M 145 120 Q 170 100 180 70" stroke="white" stroke-width="10" fill="transparent" />
        </svg>
      `;

    case 'dragon':
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <!-- Body -->
          <ellipse cx="100" cy="120" rx="45" ry="35" fill="${color}" />
          
          <!-- Head -->
          <circle cx="100" cy="70" r="35" fill="${color}" />
          
          <!-- Eyes -->
          <ellipse cx="85" cy="65" rx="9" ry="11" fill="white" />
          <ellipse cx="115" cy="65" rx="9" ry="11" fill="white" />
          <ellipse cx="85" cy="65" rx="4.5" ry="5.5" fill="black" />
          <ellipse cx="115" cy="65" rx="4.5" ry="5.5" fill="black" />
          <ellipse cx="83" cy="63" rx="2" ry="2" fill="white" />
          <ellipse cx="113" cy="63" rx="2" ry="2" fill="white" />
          
          <!-- Smile -->
          <path d="M 90 80 Q 100 89 110 80" stroke="black" stroke-width="2.5" fill="transparent" stroke-linecap="round" />
          
          <!-- Horns -->
          <path d="M 75 45 L 65 30 L 70 25 Z" fill="${color}" />
          <path d="M 125 45 L 135 30 L 130 25 Z" fill="${color}" />
          
          <!-- Wings -->
          <path d="M 60 100 Q 40 70 45 50 Q 70 70 60 100" fill="${color}" />
          <path d="M 140 100 Q 160 70 155 50 Q 130 70 140 100" fill="${color}" />
          
          <!-- Spikes -->
          <path d="M 100 40 L 95 25 L 100 30 L 105 25 L 100 40" fill="${color}" />
          <path d="M 100 85 L 95 70 L 100 75 L 105 70 L 100 85" fill="${color}" />
          <path d="M 100 100 L 95 85 L 100 90 L 105 85 L 100 100" fill="${color}" />
          <path d="M 100 115 L 95 100 L 100 105 L 105 100 L 100 115" fill="${color}" />
          
          <!-- Tail -->
          <path d="M 55 115 Q 30 120 25 95" stroke="${color}" stroke-width="12" fill="transparent" stroke-linecap="round" />
          <path d="M 25 95 L 15 85 L 20 80 Z" fill="${color}" />
        </svg>
      `;

    case 'panda':
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <!-- Body -->
          <ellipse cx="100" cy="130" rx="45" ry="40" fill="white" />
          
          <!-- Head -->
          <circle cx="100" cy="75" r="45" fill="white" />
          
          <!-- Ears -->
          <circle cx="65" cy="40" r="20" fill="black" />
          <circle cx="135" cy="40" r="20" fill="black" />
          <circle cx="65" cy="40" r="10" fill="#333" />
          <circle cx="135" cy="40" r="10" fill="#333" />
          
          <!-- Eye patches -->
          <ellipse cx="80" cy="65" rx="20" ry="18" fill="black" />
          <ellipse cx="120" cy="65" rx="20" ry="18" fill="black" />
          
          <!-- Eyes -->
          <ellipse cx="80" cy="65" rx="7" ry="9" fill="white" />
          <ellipse cx="120" cy="65" rx="7" ry="9" fill="white" />
          <ellipse cx="80" cy="65" rx="3.5" ry="4.5" fill="black" />
          <ellipse cx="120" cy="65" rx="3.5" ry="4.5" fill="black" />
          <ellipse cx="78" cy="63" rx="2" ry="2" fill="white" />
          <ellipse cx="118" cy="63" rx="2" ry="2" fill="white" />
          
          <!-- Nose -->
          <ellipse cx="100" cy="85" rx="10" ry="7" fill="black" />
          
          <!-- Mouth -->
          <path d="M 90 95 Q 100 105 110 95" stroke="black" stroke-width="2" fill="transparent" stroke-linecap="round" />
          
          <!-- Arms -->
          <ellipse cx="65" cy="130" rx="15" ry="25" fill="black" transform="rotate(-20 65 130)" />
          <ellipse cx="135" cy="130" rx="15" ry="25" fill="black" transform="rotate(20 135 130)" />
          
          <!-- Legs -->
          <ellipse cx="80" cy="160" rx="15" ry="10" fill="black" />
          <ellipse cx="120" cy="160" rx="15" ry="10" fill="black" />
          
          <!-- Belly patch -->
          <circle cx="100" cy="130" r="25" fill="${color}" />
        </svg>
      `;

    case 'princess':
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <!-- Dress -->
          <path d="M 75 90 Q 100 120 125 90 L 135 170 L 65 170 Z" fill="${color}" />
          
          <!-- Head -->
          <circle cx="100" cy="70" r="30" fill="#FFAAD4" />
          
          <!-- Hair -->
          <path d="M 70 70 Q 60 40 80 30 Q 100 25 120 30 Q 140 40 130 70" fill="#FFDE59" />
          <path d="M 75 75 Q 65 90 70 110" stroke="#FFDE59" stroke-width="8" fill="transparent" stroke-linecap="round" />
          <path d="M 125 75 Q 135 90 130 110" stroke="#FFDE59" stroke-width="8" fill="transparent" stroke-linecap="round" />
          
          <!-- Crown -->
          <path d="M 80 45 L 85 35 L 90 45 L 95 35 L 100 45 L 105 35 L 110 45 L 115 35 L 120 45 Z" fill="#FFDE59" />
          <ellipse cx="100" cy="45" rx="25" ry="5" fill="#FFDE59" />
          
          <!-- Face -->
          <ellipse cx="90" cy="65" rx="6" ry="8" fill="white" />
          <ellipse cx="110" cy="65" rx="6" ry="8" fill="white" />
          <ellipse cx="90" cy="65" rx="3" ry="4" fill="black" />
          <ellipse cx="110" cy="65" rx="3" ry="4" fill="black" />
          <ellipse cx="88" cy="63" rx="1.5" ry="1.5" fill="white" />
          <ellipse cx="108" cy="63" rx="1.5" ry="1.5" fill="white" />
          
          <!-- Blush -->
          <ellipse cx="80" cy="75" rx="8" ry="5" fill="#FF8E8E" opacity="0.6" />
          <ellipse cx="120" cy="75" rx="8" ry="5" fill="#FF8E8E" opacity="0.6" />
          
          <!-- Smile -->
          <path d="M 90 80 Q 100 90 110 80" stroke="black" stroke-width="2" fill="transparent" stroke-linecap="round" />
          
          <!-- Arms -->
          <path d="M 75 100 Q 65 110 60 130" stroke="#FFAAD4" stroke-width="8" fill="transparent" stroke-linecap="round" />
          <path d="M 125 100 Q 135 110 140 130" stroke="#FFAAD4" stroke-width="8" fill="transparent" stroke-linecap="round" />
          
          <!-- Hands -->
          <circle cx="60" cy="135" r="7" fill="#FFAAD4" />
          <circle cx="140" cy="135" r="7" fill="#FFAAD4" />
          
          <!-- Wand -->
          <rect x="140" y="105" width="5" height="30" fill="#D4B3FF" rx="2.5" />
          <path d="M 142.5 105 L 147 100 L 152 105 L 147 110 Z" fill="#FFDE59" />
          
          <!-- Decorations -->
          <circle cx="85" cy="110" r="5" fill="#FFDE59" />
          <circle cx="100" cy="120" r="5" fill="#FFDE59" />
          <circle cx="115" cy="110" r="5" fill="#FFDE59" />
        </svg>
      `;

    case 'superhero':
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <!-- Body -->
          <path d="M 75 90 L 70 170 L 130 170 L 125 90 Z" fill="${color}" />
          
          <!-- Chest emblem -->
          <circle cx="100" cy="120" r="15" fill="#5D5CDE" />
          <text x="100" y="128" font-size="20" text-anchor="middle" fill="white" font-weight="bold">B</text>
          
          <!-- Cape -->
          <path d="M 75 90 Q 100 100 125 90 L 150 160 Q 100 140 50 160 Z" fill="#5D5CDE" />
          
          <!-- Head -->
          <circle cx="100" cy="70" r="30" fill="#FFDE59" />
          
          <!-- Mask -->
          <path d="M 70 70 Q 100 85 130 70 Q 120 50 100 45 Q 80 50 70 70 Z" fill="${color}" />
          
          <!-- Eyes -->
          <ellipse cx="85" cy="65" rx="8" ry="10" fill="white" />
          <ellipse cx="115" cy="65" rx="8" ry="10" fill="white" />
          <ellipse cx="85" cy="65" rx="4" ry="5" fill="#61DAFB" />
          <ellipse cx="115" cy="65" rx="4" ry="5" fill="#61DAFB" />
          <ellipse cx="83" cy="63" rx="1.5" ry="1.5" fill="white" />
          <ellipse cx="113" cy="63" rx="1.5" ry="1.5" fill="white" />
          
          <!-- Smile -->
          <path d="M 90 85 Q 100 95 110 85" stroke="black" stroke-width="2" fill="transparent" stroke-linecap="round" />
          
          <!-- Arms -->
          <path d="M 75 100 Q 65 110 60 130" stroke="${color}" stroke-width="12" fill="transparent" stroke-linecap="round" />
          <path d="M 125 100 Q 135 110 140 130" stroke="${color}" stroke-width="12" fill="transparent" stroke-linecap="round" />
          
          <!-- Hands -->
          <circle cx="60" cy="135" r="9" fill="#FFDE59" />
          <circle cx="140" cy="135" r="9" fill="#FFDE59" />
          
          <!-- Belt -->
          <rect x="70" y="135" width="60" height="10" rx="5" fill="#FFDE59" />
          <circle cx="100" cy="140" r="5" fill="#5D5CDE" />
          
          <!-- Boots -->
          <path d="M 80 170 Q 80 180 75 185" stroke="${color}" stroke-width="10" fill="transparent" stroke-linecap="round" />
          <path d="M 120 170 Q 120 180 125 185" stroke="${color}" stroke-width="10" fill="transparent" stroke-linecap="round" />
        </svg>
      `;

    case 'wizard':
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <!-- Body -->
          <path d="M 75 100 L 70 170 L 130 170 L 125 100 Z" fill="${color}" />
          
          <!-- Head -->
          <circle cx="100" cy="80" r="30" fill="#D4B3FF" />
          
          <!-- Hat -->
          <path d="M 70 80 L 100 30 L 130 80 Z" fill="#5E17EB" />
          <ellipse cx="100" cy="80" rx="40" ry="10" fill="#5E17EB" />
          
          <!-- Face -->
          <ellipse cx="90" cy="75" rx="6" ry="8" fill="white" />
          <ellipse cx="110" cy="75" rx="6" ry="8" fill="white" />
          <ellipse cx="90" cy="75" rx="3" ry="4" fill="black" />
          <ellipse cx="110" cy="75" rx="3" ry="4" fill="black" />
          <ellipse cx="88" cy="73" rx="1.5" ry="1.5" fill="white" />
          <ellipse cx="108" cy="73" rx="1.5" ry="1.5" fill="white" />
          
          <!-- Beard -->
          <path d="M 85 85 Q 100 105 115 85 Q 100 110 85 85" fill="white" />
          
          <!-- Staff -->
          <rect x="140" y="80" width="5" height="90" fill="#8B4513" rx="2.5" />
          <circle cx="142.5" cy="70" r="10" fill="#61DAFB" />
          
          <!-- Stars -->
          <path d="M 70 50 L 72 55 L 77 55 L 74 58 L 75 63 L 70 60 L 65 63 L 66 58 L 63 55 L 68 55 Z" fill="#FFDE59" />
          <path d="M 130 60 L 132 65 L 137 65 L 134 68 L 135 73 L 130 70 L 125 73 L 126 68 L 123 65 L 128 65 Z" fill="#FFDE59" />
          
          <!-- Arms -->
          <path d="M 75 110 Q 65 120 60 140" stroke="${color}" stroke-width="10" fill="transparent" stroke-linecap="round" />
          <circle cx="60" cy="145" r="7" fill="#D4B3FF" />
          <path d="M 125 110 Q 135 120 140 140" stroke="${color}" stroke-width="10" fill="transparent" stroke-linecap="round" />
          <circle cx="140" cy="145" r="7" fill="#D4B3FF" />
        </svg>
      `;

    case 'ninja':
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <!-- Body -->
          <path d="M 75 90 L 65 170 L 135 170 L 125 90 Z" fill="#333" />
          
          <!-- Head -->
          <circle cx="100" cy="70" r="35" fill="#333" />
          
          <!-- Mask -->
          <rect x="70" y="60" width="60" height="20" fill="${color}" rx="5" />
          
          <!-- Eyes -->
          <ellipse cx="85" cy="70" rx="7" ry="9" fill="white" />
          <ellipse cx="115" cy="70" rx="7" ry="9" fill="white" />
          <ellipse cx="85" cy="70" rx="3.5" ry="4.5" fill="black" />
          <ellipse cx="115" cy="70" rx="3.5" ry="4.5" fill="black" />
          <ellipse cx="83" cy="68" rx="1.5" ry="1.5" fill="white" />
          <ellipse cx="113" cy="68" rx="1.5" ry="1.5" fill="white" />
          
          <!-- Headband -->
          <path d="M 65 55 L 135 55 L 140 65 L 60 65 Z" fill="${color}" />
          <circle cx="100" cy="60" r="7" fill="white" />
          
          <!-- Arms -->
          <path d="M 75 100 Q 65 110 60 130" stroke="#333" stroke-width="10" fill="transparent" stroke-linecap="round" />
          <path d="M 125 100 Q 135 110 140 130" stroke="#333" stroke-width="10" fill="transparent" stroke-linecap="round" />
          
          <!-- Hands -->
          <circle cx="60" cy="135" r="8" fill="${color}" />
          <circle cx="140" cy="135" r="8" fill="${color}" />
          
          <!-- Belt -->
          <rect x="65" y="120" width="70" height="10" fill="${color}" rx="5" />
          
          <!-- Legs -->
          <path d="M 80 170 Q 80 180 75 185" stroke="#333" stroke-width="10" fill="transparent" stroke-linecap="round" />
          <path d="M 120 170 Q 120 180 125 185" stroke="#333" stroke-width="10" fill="transparent" stroke-linecap="round" />
          
          <!-- Weapons -->
          <path d="M 40 110 L 50 100 L 60 110 L 50 120 Z" fill="#888" />
          <rect x="150" y="100" width="5" height="30" fill="#888" rx="2.5" />
          <ellipse cx="152.5" cy="95" rx="8" ry="3" fill="#888" />
        </svg>
      `;

    case 'alien':
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <!-- Head/Body -->
          <ellipse cx="100" cy="100" rx="50" ry="65" fill="${color}" />
          
          <!-- Eyes -->
          <ellipse cx="80" cy="80" rx="18" ry="23" fill="black" />
          <ellipse cx="120" cy="80" rx="18" ry="23" fill="black" />
          <ellipse cx="80" cy="80" rx="9" ry="14" fill="white" />
          <ellipse cx="120" cy="80" rx="9" ry="14" fill="white" />
          <circle cx="80" cy="80" r="5" fill="${color}" />
          <circle cx="120" cy="80" r="5" fill="${color}" />
          <ellipse cx="78" cy="78" rx="2" ry="2" fill="white" />
          <ellipse cx="118" cy="78" rx="2" ry="2" fill="white" />
          
          <!-- Mouth -->
          <ellipse cx="100" cy="120" rx="15" ry="8" fill="black" />
          <ellipse cx="100" cy="117" rx="13" ry="5" fill="${color}" />
          
          <!-- Antennas -->
          <line x1="85" y1="40" x2="75" y2="20" stroke="${color}" stroke-width="3" stroke-linecap="round" />
          <line x1="115" y1="40" x2="125" y2="20" stroke="${color}" stroke-width="3" stroke-linecap="round" />
          <circle cx="75" cy="20" r="5" fill="#D4B3FF" />
          <circle cx="125" cy="20" r="5" fill="#D4B3FF" />
          
          <!-- Arms -->
          <path d="M 55 100 Q 45 110 50 130" stroke="${color}" stroke-width="10" fill="transparent" stroke-linecap="round" />
          <path d="M 145 100 Q 155 110 150 130" stroke="${color}" stroke-width="10" fill="transparent" stroke-linecap="round" />
          <circle cx="50" cy="135" r="8" fill="${color}" />
          <circle cx="150" cy="135" r="8" fill="${color}" />
          
          <!-- Legs -->
          <path d="M 85 160 Q 85 175 80 185" stroke="${color}" stroke-width="10" fill="transparent" stroke-linecap="round" />
          <path d="M 115 160 Q 115 175 120 185" stroke="${color}" stroke-width="10" fill="transparent" stroke-linecap="round" />
          
          <!-- Spots -->
          <circle cx="70" cy="100" r="5" fill="#D4B3FF" />
          <circle cx="130" cy="100" r="5" fill="#D4B3FF" />
          <circle cx="85" cy="135" r="5" fill="#D4B3FF" />
          <circle cx="115" cy="135" r="5" fill="#D4B3FF" />
        </svg>
      `;

    default:
      return `
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="100" r="50" fill="${color}" />
          <text x="100" y="110" text-anchor="middle" font-size="40" fill="white">?</text>
        </svg>
      `;
  }
};

const renderAccessory = (characterType, accessory) => {
  // 統一配件位置：所有角色的帽子和皇冠都在相同的相對位置
  const getAccessoryPosition = (characterType, accessory) => {
    const basePositions = {
      // 所有角色統一的配件位置
      crown: { x: 100, y: 40, scale: 1.0, rotate: 0 },
      hat: { x: 100, y: 40, scale: 0.9, rotate: 0 }, // 統一和皇冠同位置
      star: { x: 100, y: 30, scale: 0.8, rotate: 0 },
      heart: { x: 100, y: 110, scale: 0.6, rotate: 0 }, // 心口位置
      bowtie: { x: 100, y: 110, scale: 0.8, rotate: 0 }, // 心口位置
      glasses: { x: 100, y: 70, scale: 1.0, rotate: 0 },
      music: { x: 140, y: 50, scale: 0.7, rotate: 0 }
    };

    // 特殊角色的微調
    const adjustments = {
      panda: {
        crown: { y: 30 }, // 因為熊貓耳朵大，皇冠位置稍微調高
        hat: { y: 30 },
        star: { y: 20 },
        glasses: { scale: 1.2 } // 熊貓眼部較大
      },
      alien: {
        crown: { y: 25 }, // 外星人頭部形狀特殊
        hat: { y: 25 },
        star: { y: 15 },
        glasses: { scale: 1.3, y: 80 } // 外星人眼睛位置不同
      },
      wizard: {
        crown: { y: 50, scale: 0.8 }, // 巫師已經有帽子了
        hat: { y: 50, scale: 0.7 },
        star: { y: 40 },
        glasses: { y: 75 }
      },
      princess: {
        crown: { scale: 0.8 }, // 公主已經有皇冠了
        hat: { scale: 0.8 },
        star: { scale: 0.7 },
        heart: { scale: 0.5 }
      }
    };

    const basePos = basePositions[accessory] || { x: 100, y: 40, scale: 1, rotate: 0 };
    const adjustment = adjustments[characterType]?.[accessory] || {};

    return {
      x: adjustment.x || basePos.x,
      y: adjustment.y || basePos.y,
      scale: adjustment.scale || basePos.scale,
      rotate: adjustment.rotate || basePos.rotate
    };
  };

  const pos = getAccessoryPosition(characterType, accessory);

  switch(accessory) {
    case 'crown':
      return `
        <g transform="translate(${pos.x - 100}, ${pos.y - 32}) scale(${pos.scale}) rotate(${pos.rotate} 100 32)">
          <ellipse cx="100" cy="32" rx="20" ry="3" fill="#FFD700" />
          <path d="M 80 32 L 85 20 L 90 30 L 95 18 L 100 30 L 105 18 L 110 30 L 115 20 L 120 32 Z" fill="#FFD700" />
          <circle cx="87" cy="25" r="2" fill="#FF69B4" />
          <circle cx="100" cy="22" r="2.5" fill="#4169E1" />
          <circle cx="113" cy="25" r="2" fill="#32CD32" />
          <ellipse cx="100" cy="32" rx="18" ry="2" fill="#FFA500" />
        </g>
      `;

    case 'star':
      return `
        <g transform="translate(${pos.x - 100}, ${pos.y - 35}) scale(${pos.scale}) rotate(${pos.rotate} 100 35)">
          <path d="M 100 30 L 104 40 L 115 40 L 107 47 L 111 57 L 100 50 L 89 57 L 93 47 L 85 40 L 96 40 Z" fill="#FFD700" />
          <path d="M 100 33 L 103 41 L 112 41 L 106 46 L 109 54 L 100 49 L 91 54 L 94 46 L 88 41 L 97 41 Z" fill="#FFFF00" />
          <circle cx="100" cy="43" r="2" fill="#FFA500" />
        </g>
      `;

    case 'heart':
      return `
        <g transform="translate(${pos.x - 100}, ${pos.y - 35}) scale(${pos.scale}) rotate(${pos.rotate} 100 35)">
          <path d="M 100 35 C 100 30, 93 26, 88 30 C 83 26, 76 30, 76 35 C 76 40, 100 58, 100 58 C 100 58, 124 40, 124 35 C 124 30, 117 26, 112 30 C 107 26, 100 30, 100 35 Z" fill="#FF69B4" />
          <path d="M 100 37 C 100 33, 94 30, 90 33 C 86 30, 80 33, 80 37 C 80 41, 100 55, 100 55 C 100 55, 120 41, 120 37 C 120 33, 114 30, 110 33 C 106 30, 100 33, 100 37 Z" fill="#FFB6C1" />
          <ellipse cx="93" cy="38" rx="3" ry="4" fill="#FFFFFF" opacity="0.4" />
        </g>
      `;

    case 'glasses':
      return `
        <g transform="translate(${pos.x - 100}, ${pos.y - 65}) scale(${pos.scale}) rotate(${pos.rotate} 100 65)">
          <circle cx="85" cy="65" r="14" fill="none" stroke="#2C3E50" stroke-width="2.5"/>
          <circle cx="85" cy="65" r="12" fill="rgba(135,206,250,0.15)"/>
          <circle cx="115" cy="65" r="14" fill="none" stroke="#2C3E50" stroke-width="2.5"/>
          <circle cx="115" cy="65" r="12" fill="rgba(135,206,250,0.15)"/>
          <path d="M 99 65 L 101 65" stroke="#2C3E50" stroke-width="2.5"/>
          <path d="M 71 62 L 65 59" stroke="#2C3E50" stroke-width="2"/>
          <path d="M 129 62 L 135 59" stroke="#2C3E50" stroke-width="2"/>
          <ellipse cx="81" cy="60" rx="2.5" ry="4" fill="white" opacity="0.6"/>
          <ellipse cx="111" cy="60" rx="2.5" ry="4" fill="white" opacity="0.6"/>
        </g>
      `;

    case 'hat':
      return `
        <g transform="translate(${pos.x - 100}, ${pos.y - 25}) scale(${pos.scale}) rotate(${pos.rotate} 100 25)">
          <ellipse cx="100" cy="32" rx="35" ry="6" fill="#2C3E50"/>
          <ellipse cx="100" cy="22" rx="18" ry="12" fill="#2C3E50"/>
          <ellipse cx="100" cy="15" rx="16" ry="6" fill="#34495E"/>
          <ellipse cx="100" cy="26" rx="20" ry="2.5" fill="#E74C3C"/>
          <ellipse cx="100" cy="33" rx="32" ry="4" fill="#1A252F"/>
        </g>
      `;

    case 'bowtie':
      return `
        <g transform="translate(${pos.x - 100}, ${pos.y - 95}) scale(${pos.scale}) rotate(${pos.rotate} 100 95)">
          <path d="M 88 95 L 95 90 L 95 100 Z" fill="#E74C3C"/>
          <path d="M 112 95 L 105 90 L 105 100 Z" fill="#E74C3C"/>
          <rect x="95" y="92" width="10" height="6" rx="1" fill="#C0392B"/>
          <circle cx="91" cy="94" r="1" fill="#FFFFFF" opacity="0.8"/>
          <circle cx="91" cy="97" r="1" fill="#FFFFFF" opacity="0.8"/>
          <circle cx="109" cy="94" r="1" fill="#FFFFFF" opacity="0.8"/>
          <circle cx="109" cy="97" r="1" fill="#FFFFFF" opacity="0.8"/>
        </g>
      `;

    case 'music':
      return `
        <g transform="translate(${pos.x - 100}, ${pos.y - 40}) scale(${pos.scale}) rotate(${pos.rotate} 100 40)">
          <circle cx="95" cy="45" r="4" fill="#2C3E50"/>
          <rect x="99" y="30" width="2.5" height="15" fill="#2C3E50"/>
          <path d="M 99 30 Q 108 27 112 32" stroke="#2C3E50" stroke-width="2.5" fill="none"/>
          <circle cx="112" cy="38" r="3" fill="#E74C3C"/>
          <text x="85" y="55" font-size="8" fill="#3498DB" font-family="serif">♪</text>
          <text x="115" y="50" font-size="6" fill="#9B59B6" font-family="serif">♫</text>
        </g>
      `;

    default:
      return '';
  }
};